import { useCallback, useState } from 'react';
import { saveBlob } from '@/api/client';
import { ApiClientError } from '@/api/errors';
import { useSession } from '@/session/SessionProvider';

/** Runs a PDF fetch + save and keeps the pending and error state for the button that started it. */
export function usePdfDownload() {
  const session = useSession();
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const run = useCallback(
    async (fetchBlob: () => Promise<Blob>, filename: string) => {
      setPending(true);
      setError(null);
      try {
        saveBlob(await fetchBlob(), filename);
      } catch (e) {
        if (!session.handleSessionError(e)) setError(e instanceof ApiClientError ? e : new ApiClientError(0, 'unknown'));
      } finally {
        setPending(false);
      }
    },
    [session],
  );
  return { pending, error, run, clear: () => setError(null) };
}
